<template>
<!-- 科研资讯页面 -->
  <div class="bgs">
    <Header></Header>
    <!-- 轮播图 -->
    <div class="Scientific_Banner">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in BannerList" :key="index">
            <a :href="item.url" target="_blank">
            <img :src="item.picture" alt="">
            <div class="swiper_title">{{item.title}}</div>
            </a>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <!-- 下面内容 -->
    <div class="Scientific_bx">
      <div class="Scientific_bx_left">
        <van-list v-model="loading" style="display:flex;flex-wrap: wrap;justify-content: space-between;"
            :finished="finished" finished-text="没有更多了" @load="scroll">
        <!-- 有图的 -->
        <div class="Scientific_bx_left_list" v-for="(item,index) in Frontier_List" @click="Go_InformationDetails(item.id)"  :key="index">
          <div class="Scientific_bx_left_list_left" v-if="item.img!=''">
            <img :src="item.img" alt="">
          </div>
          <div class="Scientific_bx_left_list_right" v-if="item.img!=''">
            <div class="title">
              {{item.title}}
            </div>
            <div class="Scientific_bx_left_list_right_bottom">
              <div class="list_right_bottom_left">
                <img :src="item.headimg" alt="">
                <span style="display:inline-block;width:75px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">{{item.nickname}}</span>
                <span style="color:#999;">{{item.create_time.slice(0,11)}}</span>
              </div>
              <div class="list_right_bottom_right">
                <div class="list_right_bottom_right_imgtext">
                  <img src="../assets/img/dianzan_icon.png" alt="">
                  <span>{{item.num_praise}}</span>
                </div>
                <div class="list_right_bottom_right_imgtext">
                  <img src="../assets/img/pinglun_icon.png" alt="">
                  <span>{{item.num_comment}}</span>
                </div>
                <div class="list_right_bottom_right_imgtext" @click.stop="Go_wb(item.title,item.id)">
                  <img src="../assets/img/fenxiang_icon.png" alt="">
                  <span>分享</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 没图的 -->
          <div class="Scientific_bx_left_list_right" v-if="item.img==''" style="width:100%;height:180px;">
            <div class="title" style="margin-bottom:50px;">
              {{item.title}}
            </div>
            <div class="Scientific_bx_left_list_right_bottom">
              <div class="list_right_bottom_left">
                <img :src="item.headimg" alt="">
                <span style="display:inline-block;width:50px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;">{{item.nickname}}</span>
                <span style="color: rgb(153, 153, 153);">{{item.create_time.slice(0,11)}}</span>
              </div>
              <div class="list_right_bottom_right">
                <div class="list_right_bottom_right_imgtext">
                  <img src="../assets/img/dianzan_icon.png" alt="">
                 <span>{{item.num_praise}}</span>
                </div>
                <div class="list_right_bottom_right_imgtext">
                  <img src="../assets/img/pinglun_icon.png" alt="">
                   <span>{{item.num_comment}}</span>
                </div>
                <div class="list_right_bottom_right_imgtext">
                  <img src="../assets/img/fenxiang_icon.png" alt="">
                  <span>分享</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        </van-list>
      </div>
      <div class="Scientific_bx_right">
        <!-- 作者推荐 -->
        <div class="Author_recommendation">
          <div class="Author_recommendation_top">
            <div class="Author_recommendation_top_l">
              <div class="shugang"></div>
              <div class="titles">智库推荐</div>
            </div>
            <div class="more" @click="Go_ThinkTank">更多 ></div>
          </div>
          <div class="Author_recommendation_content">
            <div class="Author_recommendation_list" v-for="(item,index) in zzlist" @click="Go_AuthorsHome(item.qudong_uid,item.id)" :key="index">
              <img :src="item.headimgurl" alt="">
              <div class="Author_recommendation_list_title">{{item.nickname}}</div>
            </div>
          </div>
          <div class="Author_recommendation_bottom">
            <div class="Change_batch" @click="ChangeBatch()">
              <img src="../assets/img/huanyipi_icon.png" alt="">
              <span>换一批</span>
            </div>
          </div>
        </div>
        <!-- 热点推荐 -->
        <div class="Author_recommendation" style="height:auto;">
          <div class="Author_recommendation_top">
            <div class="Author_recommendation_top_l">
              <div class="shugang"></div>
              <div class="titles">热点推荐</div>
            </div>
          </div>
          <div class="Hot_recommendation">
            <div class="Hot_list" v-for="(item,index) in Hot_list" :key="index" @click="Go_InformationDetails(item.id)">
              <div class="Hot_list_title">{{item.title}}</div>
              <div class="Hot_list_data">{{item.create_time.slice(5,10)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Axios from "axios";
import Swiper from "swiper";
export default {
  metaInfo(){
     return{
        title: '科研资讯_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  data() {
    return {
      load: true,
      page: 1,
      loading: false,
      finished: false,
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      zzlist: [],
      Frontier_List:[],
      Hot_list:[],
      BannerList:[],
    };
  },
  components: {
    Header,
    Footer,
  },
  methods: {
    Go_AuthorsHome(uid,id){
      var ids='';
      if(uid==null){
        ids=id
      }else{
        ids=uid
      }
      this.$router.push({ name: "AuthorsHome",query: { id: ids }});
    },
    Go_ThinkTank(){
      this.$router.push({ name: "ThinkTank"});
    },
     // banner图
    Banner(){
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/banner_index",
        params: {
        },
      }).then((res) => {
        ////console.log(res.data.data);
        this.BannerList = res.data.data;
      });
    },
    // 跳转资讯详情
    Go_InformationDetails(id){
      console.log(id)
       this.$router.push({ path: "/InformationDetails", query: { id: id } });
    },
    Go_wb(title,id) {
      let urls = "https://tousu.qudong.com//#/Details?id=" + id;
      window.open(
        "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(urls) +
          "&title=" +
          title +
          "&summary=" +
          title
      );
    },
    // 资讯列表
    scroll() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/index",
        params: {
          page: this.page,
        },
      }).then((res) => {
        //console.log(res.data.data.data);
      setTimeout(() => {
          this.page = this.page + 1;
          if (res.data.data.data.length > 0) {
            this.Frontier_List.push(...res.data.data.data);
            this.loading = false;
          } else {
            this.finished = true;
          }
        }, 500);
        // this.Frontier_List = res.data.data.data;
      });
    },
    ChangeBatch(){
      Axios({
      method: "get",
      url: "https://researchadmin.qudong.com/api/cele_user_round",
      params: {
      },
    }).then((res) => {
      ////console.log(res.data.data);
      this.zzlist=res.data.data;
    });
    },
    // 轮播
    Swiper() {
      var that = this;
      setTimeout(() => {
        var mySwiper = new Swiper(".swiper-container", {
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop: true,
          autoplay: true,
          observer: true,
          observeParents: true,

        });
        //鼠标覆盖停止自动切换
        mySwiper.el.onmouseover = function () {
          mySwiper.autoplay.stop();
        };

        //鼠标离开开始自动切换
        mySwiper.el.onmouseout = function () {
          mySwiper.autoplay.start();
        };
      }, 300);
    },
    // 热点推荐
    Hot_List(){
      Axios({
      method: "get",
      url: "https://researchadmin.qudong.com/api/content_relevants",
      params: {
      },
    }).then((res) => {
      ////console.log(res.data.data);
      this.Hot_list=res.data.data;
    });
    }
  },
  mounted() {
    this.ChangeBatch();
    this.Swiper();
    this.Hot_List();
    this.Banner();
  },
};
</script>

<style scoped>
.bgs {
  background: #f5f7f9;
}
.Scientific_Banner {
  width: 100%;
  height: 480px;
}
.swiper-container {
  width: 100%;
  height: 480px;
}
.swiper-container img {
  width: 100%;
  height: 480px;
  object-fit: cover;
}
/* 下面内容 */
.Scientific_bx {
  width: 1200px;
  margin: 20px auto 50px;
  display: flex;
  justify-content: space-between;
}
.Scientific_bx_left {
  width: 860px;
  background: #fff;
}
.Scientific_bx_right {
  width: 320px;
  background: #f5f7f9;
}
.Scientific_bx_left_list {
  width: 820px;
  /* margin: 20px; */
  margin-left:20px;
  padding:20px 0 20px 0px;
  /* padding-bottom: 20px; */
  display: flex;
  /* justify-content: space-between; */
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
}
.Scientific_bx_left_list_left {
  width: 300px;
  height: 180px;
  margin-right: 20px;
}
.Scientific_bx_left_list_left img {
  width: 300px;
  height: 180px;
  border-radius: 6px;
}
.Scientific_bx_left_list_right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* margin-left:20px; */
}
.Scientific_bx_left_list_right .title {
  font-size: 23px;
   overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.Scientific_bx_left_list_right_bottom {
  display: flex;
  justify-content: space-between;
}
.list_right_bottom_left {
  display: flex;
  align-items: center;
  margin-right:40px;
}
.list_right_bottom_left img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 8px;
}
.list_right_bottom_left span{
  margin-right: 15px;
}
.list_right_bottom_right {
  display: flex;
  align-items: center;
  color:#999;
}

.list_right_bottom_right_imgtext {
  display: flex;
  margin-right: 20px;
}
.list_right_bottom_right_imgtext img {
  margin-right: 5px;
}
.Author_recommendation {
  width: 320px;
  height: 316px;
  background: #fff;
  margin-bottom: 20px;
}
.shugang {
  width: 4px;
  height: 28px;
  background: #3463db;
}
.titles {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #3463db;
  margin-left: 10px;
}
.Author_recommendation_top {
  width: 320px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}
.Author_recommendation_top_l {
  display: flex;
}
.more {
  font-size: 16px;
  font-family: Source Han Sans CN;
  color: #999999;
  margin-right: 15px;
  cursor: pointer;
}
.Author_recommendation_content {
  width: 260px;
  margin: 20px auto 0;
  /* padding:20px 30px 0; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
}
.Author_recommendation_list {
  cursor: pointer;
  width: 33%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.Author_recommendation_list img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-bottom: 10px;
}
.Author_recommendation_bottom {
  width: 320px;
  height: 50px;
  line-height: 50px;
}
.Change_batch {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.Change_batch img {
  margin-right: 10px;
}
.Hot_list {
  display: flex;
  width: 290px;
  margin: 20px auto;
  /* padding:0px 15px; */
  justify-content: space-between;
  cursor: pointer;
}
.Hot_list_title {
  width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  color:#666;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.Hot_recommendation {
  padding-bottom: 5px;
}
.Hot_list_data {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.Author_recommendation_list_title{
  width:80px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  text-align:center;
  -webkit-box-orient: vertical;
  font-size: 14px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
}

>>> .van-list__finished-text {
  width: 860px;
  height:40px;
  line-height:40px;
  text-align:center;
}

>>> .van-list__loading {
  width: 860px;
   display:flex;
   justify-content: center;
}

.swiper_title{
     width: 100%;
    height: 50px;
    color: #fff;
    font-size: 22px;
    line-height: 50px;
    text-align: center;
    letter-spacing: 5px;
    position: absolute;
    bottom: 36px;
    background: rgba(0,0,0,0.4);
}
</style>